import {
  candidateAssessmentConstants,
} from "../../_constants";

const initialState = {};

// view assigned interview kit reducer
export const get_assessment_kit_details_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateAssessmentConstants.GET_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assessmentKitDetailsData: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

export const accept_assessment_kit_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateAssessmentConstants.ACCEPT_ASSESSMENT_KIT_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateAssessmentConstants.ACCEPT_ASSESSMENT_KIT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        acceptAssessmentData: action.payload,
      };
    case candidateAssessmentConstants.ACCEPT_ASSESSMENT_KIT_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

export const get_assessment_next_question_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateAssessmentConstants.GET_ASSESSMENT_NEXT_QUESTION_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSESSMENT_NEXT_QUESTION_ACTION_SUCCESS:
      return {
        type: "alert-success",
        nextQuestionData: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSESSMENT_NEXT_QUESTION_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

export const save_assessment_question_response_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateAssessmentConstants.SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateAssessmentConstants.SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        savedQuestionData: action.payload,
      };
    case candidateAssessmentConstants.SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};


export const get_candidate_assigned_assessment_kits_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KITS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KITS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        candidateAssignedAssessmentsData: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KITS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};

export const get_assigned_assessment_kit_details_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        candidateAssignedAssessmentData: action.payload,
      };
    case candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};
